const leadsFileValidator = (filename) => {
    const fileTypes = ["csv"]
    const lastDot = filename.lastIndexOf('.')
    const ext = filename.substring(lastDot + 1)
    const valid = fileTypes.includes(ext)

    return {
        extValid: valid,
        ext: ext,
    }
}

export default leadsFileValidator

